import { BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM } from '../../actions/types'

const estadoInicial = null

export default function reducerOpcaoDescontoMeiaPassagem (state = estadoInicial, action) {
  switch (action.type) {
    case BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
